<div class="myModal">
  <div class="modal-header">
    <button aria-label="Close" (click)="exitModal()" class="close"  aria-label="close">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>
  <div class="modal-body">
    <p *ngIf="mode===1" style="white-space: pre-line">{{ presseMessages.content_create | translate }}</p>
    <p *ngIf="mode===2" style="white-space: pre-line">{{ presseMessages.content_update | translate }}</p>
    <form class="form" [formGroup]="form">
      <app-form-input [parentForm]="form" [label]="presseMessages.intitule | translate" [type]="'text'"
      [rule]="'required'" [name]="'intitule'" title="intitule"></app-form-input>
      <app-form-input [parentForm]="form" [label]="presseMessages.email | translate" [type]="'email'"
      [rule]="'required'" [name]="'email'" title="email"></app-form-input>
      <app-form-input [parentForm]="form" [label]="presseMessages.contact | translate" [type]="'text'"
      [rule]="''" [name]="'contact'" title="contact"></app-form-input>
      <app-form-input [parentForm]="form" [label]="presseMessages.telephone | translate" [type]="'text'"
      [rule]="''" [name]="'telephone'" title="telephone"></app-form-input>
      <app-form-input [parentForm]="form" [label]="presseMessages.departement | translate" [type]="'select'"
        [optionsWithCode]="optionsSelect" [disabled]="false" [rule]="''"
        [errorMessage]="" [name]="'departement'" title="departement">
      </app-form-input>
    </form>
  </div>
  <div class="modal-footer">
    <button *ngIf="mode===2" aria-label="supprimer" (click)="delete()" class="btn btn-outline-primary" 
      aria-label="close">{{ presseMessages.supprimer | translate }}</button>
    <button aria-label="confirmer"[disabled]="(!form.valid)" (click)="valider()" class="btn btn-primary" 
      aria-label="close">{{ presseMessages.confirmer | translate }}</button>
    <button aria-label="retour" (click)="exitModal()" class="btn btn-outline-primary" 
      aria-label="close">{{ presseMessages.retour | translate }}</button>
  </div>
</div>
